import { css } from '@emotion/core';
import { media, variables, rgba } from '@domain-group/fe-brary';
import { colours, typography } from '@domain-group/fe-co-allhomes-design-system';
var colour = variables.colour;
var headingM = typography.headingM,
  body = typography.body,
  bodyLongBold = typography.bodyLongBold,
  bodyLong = typography.bodyLong;
export var container = {
  name: "lf31h",
  styles: "position:relative;padding:24px;user-select:none;margin-bottom:10px;"
};
export var header = {
  name: "69i1ev",
  styles: "display:flex;justify-content:space-between;align-items:center;"
};
export var headerButton = {
  name: "9t8fgp",
  styles: "padding-right:0;"
};
export var heading = /*#__PURE__*/css(typography.headingM, " color:", colours.neutral700, ";");
export var modalFooter = /*#__PURE__*/css("display:flex;width:100%;height:100%;padding:0 16px;align-items:center;justify-content:center;", media('>=tablet'), "{justify-content:space-between;}");
export var modalFooterButton = /*#__PURE__*/css(media('<tablet'), "{display:none;}");
export var card = {
  name: "1jbawm2",
  styles: "margin:16px 0;"
};
export var cardTitle = /*#__PURE__*/css(headingM, ";margin-bottom:8px;color:", colour.neutral900, ";");
export var cardSubtitle = /*#__PURE__*/css(body, ";margin-bottom:8px;color:", colour.neutral700, ";");
export var cardSubtitlePrefix = {
  name: "1bpvmlm",
  styles: "padding-right:12px;"
};
export var cardSubtitleSuffix = {
  name: "vxcmzt",
  styles: "display:inline-flex;"
};
export var cardMessage = /*#__PURE__*/css(bodyLong, ";position:relative;height:48px;overflow:hidden;margin:0;&:after{content:'... more';position:absolute;right:0;bottom:0;width:220px;color:", colour.secondary, ";background:linear-gradient( 270deg,", colour.neutral100, " 40%,", rgba(colour.neutral100, 0), " );padding:0 12px 0 8px;text-align:right;", bodyLongBold, ";margin:0;}", media('>=tablet'), "{height:24px;}");